import React from 'react'
import {
  CFImage,
  CFLink,
  CFView,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { yelp, facebook, instagram, zomato } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView mv="20px" column justifyStart>
          <CFView h3 futura bold color="#BF9829" mb="20px">
            SOCIAL MEDIA
          </CFView>
          <CFView row center black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.instagram.com/enishi.jp.kitchen/?hl=en"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={facebook}
                alt="Enishi Japanese Kitchen Yelp"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/enishi.jp.kitchen/?hl=en"
            >
              <CFImage
                w="50px"
                pr="10px"
                src={instagram}
                alt="Enishi Japanese Kitchen Yelp"
              />
            </CFLink>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView mb="13px" mt="15px" column justifyStart>
          <CFView h3 futura bold color="#BF9829" mb="15px">
            SOCIAL MEDIA
          </CFView>
          <CFView row justifyStart alignCenter black bold>
            {/* <CFLink
              target="_blank"
              href="https://www.instagram.com/enishi.jp.kitchen/?hl=en"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={facebook}
                alt="Enishi Japanese Kitchen Yelp"
              />
            </CFLink> */}
            <CFLink
              target="_blank"
              href="https://www.instagram.com/enishi.jp.kitchen/?hl=en"
            >
              <CFImage
                w="45px"
                pr="10px"
                src={instagram}
                alt="Enishi Japanese Kitchen Yelp"
              />
            </CFLink>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
